<template lang="pug">
.oe-second-background
    oc-section( sectionId='oe', title='Ortografía Empresarial', :tabsContent='tabsContent',nextRef='#ma')
</template>

<script>
import OcSection from '@/components/shared/Section.vue'
import SECTION from  '@/constants/section-types'

export default {
    components: { OcSection },
    data() {
        return {
            SECTION,
            tabsContent: [
                { 
                    id: 'whatis', 
                    label: '¿Qué es?', 
                    active: true,
                    inverted: true,
                    content: { 
                        type: SECTION.DEFINITION,
                        img: `${HOMEURL}img/oe/logo.png`,
                        incrementImg: 1,
                        pUrl: '',
                        html: 'Curso – Taller diseñado para las empresas, creando un sistema organizacional y trabajo en equipo conociendo y capitalizando la información personal de sus integrantes para una mejora continúa logrando una cultura de calidad y calidez, bajo una estructura funcional y productiva.'
                    }
                },
                { 
                    id: 'info', 
                    label: 'Diagnóstico de Empresas', 
                    active: false,
                    content: {
                        type: SECTION.TEXT,
                        html: 'Ofrece el único y exclusivo Diagnostico de Capital Humano para alinear y fortalezas y habilidades que ayudaran a lograr los proyectos y objetivos de la Empresa exitosamente. Elevando la la cultura organizacional y el trabajo en equipo.<br><br>Los Beneficios que se obtienen en con este Diagnostico es alinear al personal para poner en sintonía la información de la empresa con la información cerebral del personal, llevando al colaborador a descubrir su información personal escrita en su cerebro por su historia individual.<br><br>Conociendo que tan comprometido esta con la el y con la empresa para lograr para lograr juntos el éxito de la empresa, al entenderse y comprenderse podrá desarrollar sus habilidades incorporándose así a realizar trabajo en equipo, por el incremento de su habilidad de comunicación Efectiva-Afectiva.<br><br>Con todo lo anterior se Unificara la cultura de la empresa practicando los valores ejecutando la misión por medio del respeto y compromiso de su actividad individual por departamento, empatándolo con el resto de la empresa.',
                    } 
                },
                { 
                    id: 'photos', 
                    label: 'Fotos', 
                    active: false,
                    content: {
                        type: SECTION.POTHOS,
                        timeInterval: 20000,
                        slides: [
                            `${HOMEURL}img/oe/slides/1.jpg`,
                            `${HOMEURL}img/oe/slides/2.jpg`,
                            `${HOMEURL}img/oe/slides/3.jpg`,
                            `${HOMEURL}img/oe/slides/4.jpg`,
                            `${HOMEURL}img/oe/slides/5.jpg`,
                            `${HOMEURL}img/oe/slides/6.jpg`,
                            `${HOMEURL}img/oe/slides/7.jpg`,
                            `${HOMEURL}img/oe/slides/8.jpg`,
                            `${HOMEURL}img/oe/slides/9.jpg`,
                            `${HOMEURL}img/oe/slides/10.jpg`
                        ]
                    } 
                }
            ]
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/landing/Section3.vue